import { Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import CustomizedDatePicker from "component/customizedDatePicker/customized-date-picker.js";

export default function SubscribeDateField({
  control,
  error,
  validateDobValue,
}) {
  const intl = useIntl();

  return (
    <div className="form-label row">
      <div className="col-xl-4 col-lg-3">
        <label>
          <FormattedMessage id="dob" />:
        </label>
      </div>
      <div className="col-xl-8 col-lg-9">
        <div
          className={`form-label-container ${error?.message ? "mb-3" : ""}`}
        >
          <Controller
            control={control}
            name="dob"
            render={({ field }) => (
              <CustomizedDatePicker
                dateFormat="dd/MM/yyyy"
                placeholderText={intl.formatMessage({
                  id: "select-date",
                })}
                onChange={(e) => {
                  const value = e.target.value;
                  field.onChange(value);
                  validateDobValue(value);
                }}
                value={field.value}
                minDate={new Date("1900-01-01").toJSON().slice(0, 10)}
                maxDate={new Date().toJSON().slice(0, 10)}
                className={`form-control ${error ? "is-invalid px-4" : ""}`}
              />
            )}
          />
          <span>*</span>
        </div>
        {error?.message && (
          <div role="alert" className="alert alert-danger py-1">
            {error.message}
          </div>
        )}
      </div>
    </div>
  );
}
